/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotCustomCopilotsService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './CopilotCustomCopilotsService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotCustomCopilotsService#createPortalCopilot
 */
export const CREATE_PORTAL_COPILOT_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CopilotCustomCopilotsService_createPortalCopilot';
export const CREATE_PORTAL_COPILOT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_PORTAL_COPILOT_MUTATION_FIELD_NAME,
  args: ['name', 'welcomeMessage', 'instructions', 'webSearchEnabled', 'status', 'knowledgeBoxIds'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createPortalCopilotRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotCustomCopilotsService#duplicatePortalCopilot
 */
export const DUPLICATE_PORTAL_COPILOT_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CopilotCustomCopilotsService_duplicatePortalCopilot';
export const DUPLICATE_PORTAL_COPILOT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DUPLICATE_PORTAL_COPILOT_MUTATION_FIELD_NAME,
  args: ['customCopilotId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.duplicatePortalCopilotRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotCustomCopilotsService#updatePortalCopilot
 */
export const UPDATE_PORTAL_COPILOT_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CopilotCustomCopilotsService_updatePortalCopilot';
export const UPDATE_PORTAL_COPILOT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_PORTAL_COPILOT_MUTATION_FIELD_NAME,
  args: ['customCopilotId', 'name', 'welcomeMessage', 'instructions', 'webSearchEnabled', 'enabled', 'status', 'knowledgeBoxIds'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.updatePortalCopilotRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotCustomCopilotsService#deletePortalCopilot
 */
export const DELETE_PORTAL_COPILOT_MUTATION_FIELD_NAME = 'com_hubspot_copilot_rpc_CopilotCustomCopilotsService_deletePortalCopilot';
export const DELETE_PORTAL_COPILOT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_PORTAL_COPILOT_MUTATION_FIELD_NAME,
  args: ['customCopilotId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.deletePortalCopilotRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotCustomCopilotsService#listCopilots
 */
export const LIST_COPILOTS_QUERY_FIELD_NAME = 'com_hubspot_copilot_rpc_CopilotCustomCopilotsService_listCopilots';
export const LIST_COPILOTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_COPILOTS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.listCopilotsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotCustomCopilotsService#listCopilotsSummaries
 */
export const LIST_COPILOTS_SUMMARIES_QUERY_FIELD_NAME = 'com_hubspot_copilot_rpc_CopilotCustomCopilotsService_listCopilotsSummaries';
export const LIST_COPILOTS_SUMMARIES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_COPILOTS_SUMMARIES_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.listCopilotsSummariesRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.CopilotCustomCopilotsService#getCopilot
 */
export const GET_COPILOT_QUERY_FIELD_NAME = 'com_hubspot_copilot_rpc_CopilotCustomCopilotsService_getCopilot';
export const GET_COPILOT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COPILOT_QUERY_FIELD_NAME,
  args: ['customCopilotId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getCopilotRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});